export default function WhatYouGet() {
  const benefits = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Treino Personalizado',
      description: 'Organizado conforme sua rotina, nível, histórico e objetivo (emagrecimento ou hipertrofia).',
      color: 'purple'
    },
    {
      icon: 'ri-settings-3-line',
      title: 'Ajustes de Treino',
      description: 'Você envia seu feedback e eu ajusto cargas, repetições, estratégias e estímulos.',
      color: 'pink'
    },
    {
      icon: 'ri-video-line',
      title: 'Correção de Execução',
      description: 'Envie vídeos dos exercícios e receba correção de postura, técnica e ativação muscular.',
      color: 'indigo'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4 font-montserrat">
            O Seu Plano de <span className="text-purple-600">Evolução</span>
          </h2>
          <p className="text-xl text-gray-600 font-poppins">
            Simples, Completo e Profissional
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-purple-400 to-purple-600 rounded-full mx-auto mt-4"></div>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-purple-200 group">
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-file-list-3-line text-purple-600 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 font-poppins">
                Treinos específicos para o público feminino
              </h3>
              <p className="text-gray-600 leading-relaxed font-inter">
                Organizado conforme sua rotina, nível, histórico e objetivo (emagrecimento ou hipertrofia).
              </p>
              <div className="mt-6">
                <i className="ri-check-double-line text-green-500 text-2xl"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-purple-200 group">
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-settings-3-line text-purple-600 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 font-poppins">
                Ajustes e Correção de Treino
              </h3>
              <p className="text-gray-600 leading-relaxed font-inter">
                Envie vídeos dos exercícios e receba correção de postura, técnica e ativação muscular.
              </p>
              <div className="mt-6">
                <i className="ri-check-double-line text-green-500 text-2xl"></i>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-purple-200 group">
            <div className="text-center">
              <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-bar-chart-grouped-line text-purple-600 text-3xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 font-poppins">
                Treino simples, intermediário e avançado
              </h3>
              <p className="text-gray-600 leading-relaxed font-inter">
                Progressão inteligente que evolui com você, do básico ao avançado, respeitando seu ritmo e capacidade.
              </p>
              <div className="mt-6">
                <i className="ri-check-double-line text-green-500 text-2xl"></i>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-16 bg-gradient-to-r from-purple-50 to-pink-50 rounded-3xl p-8">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4 font-montserrat">
              Tudo isso por <span className="text-purple-600">30 dias completos</span>
            </h3>
            <p className="text-lg text-gray-700 mb-6 font-inter">
              Acompanhamento direto, ajustes personalizados e suporte total para sua evolução
            </p>
            
            <div className="grid md:grid-cols-3 gap-6">
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-calendar-check-line text-purple-600 text-xl"></i>
                <span className="font-medium text-gray-800 font-poppins">30 Dias de Mentoria</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-customer-service-2-line text-green-600 text-xl"></i>
                <span className="font-medium text-gray-800 font-poppins">Suporte Direto</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <i className="ri-refresh-line text-purple-600 text-xl"></i>
                <span className="font-medium text-gray-800 font-poppins">Ajustes Ilimitados</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
